import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCampaignStore } from '../stores/campaignStore';
import { Gift } from 'lucide-react';

/**
 * Root page ("/") that checks for active campaigns and redirects.
 * If only one active campaign exists, redirects to its slug.
 * If none, shows a message.
 */
export function RootRedirect() {
  const navigate = useNavigate();
  const { loadActiveCampaign } = useCampaignStore();
  const [loading, setLoading] = useState(true);
  const [noCampaign, setNoCampaign] = useState(false);

  useEffect(() => {
    loadActiveCampaign().then((campaign) => {
      if (campaign?.slug) {
        navigate(`/${campaign.slug}`, { replace: true });
      } else {
        setNoCampaign(true);
        setLoading(false);
      }
    });
  }, []);

  if (loading && !noCampaign) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-rchlo-green mb-4" />
        <p className="text-sm text-gray-500">Verificando campanhas...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-6">
      <div className="card max-w-md w-full text-center py-10">
        <div className="w-16 h-16 bg-rchlo-green/10 rounded-full flex items-center justify-center mx-auto mb-4">
          <Gift size={32} className="text-rchlo-green" />
        </div>
        <h2 className="text-xl font-bold text-gray-900 mb-2">Nenhuma campanha ativa</h2>
        <p className="text-sm text-gray-500">
          No momento não há campanhas disponíveis para participação.
        </p>
      </div>
    </div>
  );
}
